var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorIconBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7998 12C22.7998 17.9646 17.9645 22.8 11.9998 22.8C6.03515 22.8 1.19983 17.9646 1.19983 12C1.19983 6.03528 6.03515 1.19995 11.9998 1.19995C17.9645 1.19995 22.7998 6.03528 22.7998 12Z",
    fill: "#EB0042"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 14.4C11.7611 14.4 11.5322 14.2974 11.3634 14.1148C11.1946 13.9321 11.0998 13.6845 11.0998 13.4262L11.0998 6.97368C11.0998 6.71543 11.1946 6.46776 11.3634 6.28515C11.5322 6.10254 11.7611 5.99995 11.9998 5.99995C12.2385 5.99995 12.4674 6.10254 12.6362 6.28515C12.805 6.46776 12.8998 6.71543 12.8998 6.97368V13.4262C12.8998 13.6845 12.805 13.9321 12.6362 14.1148C12.4674 14.2974 12.2385 14.4 11.9998 14.4Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 16.2C11.3371 16.2 10.7998 16.7372 10.7998 17.4C10.7998 18.0627 11.3371 18.6 11.9998 18.6C12.6625 18.6 13.1998 18.0627 13.1998 17.4C13.1998 16.7372 12.6625 16.2 11.9998 16.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIconBanner);
export default __webpack_public_path__ + "static/media/error-icon-banner.443dc8385a86cb40724a6b8bb6c6ca75.svg";
export { ForwardRef as ReactComponent };